import { GButton } from "./GButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import styles from "./GLinkButton.module.css";
import { useState } from "react";
import IFrameModal from "./IFrameModal";

export interface GIFrameModalProps {
  url: string;
  title: string;
  icon: IconDefinition;
}

export const GIFrameModal = ({ url, title, icon }: GIFrameModalProps) => {
  const [confluenceModalContent, setConfluenceModalContent] = useState("");
  const [confluenceModalIsOpen, setConfluenceModalIsOpen] = useState(false);

  const handleCloseConfluenceModal = () => {
    setConfluenceModalIsOpen(false);
    setConfluenceModalContent("");
  };

  const handleConfluencePage = (url: string) => {
    if (url) {
      setConfluenceModalContent(url);
      setConfluenceModalIsOpen(true);
    }
  };

  return (
    <>
      <IFrameModal
        modalContent={confluenceModalContent}
        handleCloseModal={handleCloseConfluenceModal}
        isModalOpen={confluenceModalIsOpen}
      />
      <GButton
        variant="contained"
        disableElevation
        color="primary"
        size="large"
        endIcon={<FontAwesomeIcon icon={icon} />}
        className={styles.watchButton}
        onClick={() => handleConfluencePage(url)}
      >
        {title}
      </GButton>
    </>
  );
};
